/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/countries",
    },
    (router) => {
      router.push({
        id: "@api/country@search",
        path: "",
      });
    },
  );
}
